import { useMutation } from '@tanstack/react-query';
import { previewGlobalFieldBindings } from '@dealstack/frontend/shared/dataExchange/services/documentTemplates.service';
import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { documentTemplateMutationError } from '@dealstack/frontend/app/pages/DocumentTemplates/api/documentTemplateMutationError';

export const useGlobalFieldBindingPreview = () => {
	const tDefault = useTranslationDefault();

	return useMutation({
		mutationFn: (templateId: string) => previewGlobalFieldBindings(templateId),
		onError: (error: unknown) => documentTemplateMutationError(error, tDefault),
	});
};
